export const GET_SWAGBAG = 'GET_SWAGBAG';
export const SET_SWAGBAG = 'SET_SWAGBAG';
export const REMOVE_SWAGBAG_ITEM = 'REMOVE_SWAGBAG_ITEM';
export const REMOVE_FROM_SWAGBAG = 'REMOVE_FROM_SWAGBAG';
export const ADD_SWAGBAG_ITEM = 'ADD_SWAGBAG_ITEM';
